import React from 'react'
import { View, StyleSheet, Image } from 'react-native'
import { observer } from 'mobx-react'
import { IconBlueTapeTextLogo } from '../../../../assets/icons'
import RootStore from '../../../../store'

interface ITopBarProps {
  buttonRight?: React.ReactNode
  buttonLeft?: React.ReactNode
}

export const TopBarGuestMobile = observer(
  ({ buttonRight, buttonLeft }: ITopBarProps) => {
    const { branding } = RootStore
    const topBarLogo = branding ? (
      <Image
        source={{ uri: branding?.logoUrl }}
        style={{ height: 54, width: 151 }}
        resizeMode="contain"
      />
    ) : (
      <IconBlueTapeTextLogo />
    )
    return (
      <View style={styles.topBarView}>
        {buttonLeft ? (
          <View
            style={styles.buttonContainerLeft}
            testID={'left-topbar-btn-container'}
          >
            {buttonLeft}
          </View>
        ) : (
          <View style={styles.emptyContainer} />
        )}
        <View style={styles.logoContainer} testID={'centered-bt-icon-top-bar'}>
          {topBarLogo}
        </View>
        {buttonRight ? (
          <View
            style={styles.buttonContainerRight}
            testID={'right-topbar-btn-container'}
          >
            {buttonRight}
          </View>
        ) : (
          <View style={styles.emptyContainer} />
        )}
      </View>
    )
  },
)

const styles = StyleSheet.create({
  topBarView: {
    width: '100%',
    maxWidth: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderBottomColor: '#E6EBEE',
    height: 66,
    marginBottom: 2,
  },
  buttonContainerLeft: {
    flex: 1,
    alignItems: 'flex-start',
  },
  buttonContainerRight: {
    flex: 1,
    alignItems: 'flex-end',
  },
  logoContainer: {
    width: '30%',
    alignItems: 'center',
    alignSelf: 'center',
  },
  emptyContainer: {
    flex: 1,
  },
})
